import React from "react";

const PatientInfo = () => {
  return (
    <>
      <div className="grid grid-cols-2 gap-10 p-10">
        {/* ROW1 */}
        <div>
          <p>FullName</p>
          <br />
          <input
            type="text"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
        <div>
          <p>Patient ID</p>
          <br />
          <input
            type="text"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
        {/* Row2 */}
        <div>
          <p>Title</p>
          <br />
          <input
            type="text"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
        <div>
          <p>DOB</p>
          <br />
          <input
            type="text"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
        {/* row 3 */}

        <div>
          <p>Age</p>
          <br />
          <input
            type="text"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
        <div>
          <p>Patient Category</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        {/* row4 */}

        <div>
          <p>Occupation</p>
          <br />
          <input
            type="text"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
        <div>
          <p>Address</p>
          <br />
          <input
            type="text"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
        {/* row 5 */}
        <div>
          <p>Mobile</p>
          <br />
          <input
            type="text"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
        <div>
          <p>Email</p>
          <br />
          <input
            type="email"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
        {/* row 6 */}
        <div>
          <p>Benifits</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Driver</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        {/* row 7 */}
        <div>
          <p>Diabetic</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Galaucoma</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        {/* row 8 */}
        <div>
          <p>CL Weather</p>
          <br />
          <select className="w-[80%] bg-gray-100 p-3 rounded-md">
            <option value="select">Select</option>
          </select>
        </div>
        <div>
          <p>Date</p>
          <br />
          <input
            type="date"
            placeholder="Type here"
            className="p-3 bg-gray-100 rounded-md w-[80%]"
          />
        </div>
      </div>
      <div className="text-right">
        <button className="bg-[#4C004A] hover:bg-[#544354] text-white rounded-md py-2 px-10 my-10 mr-6">
          Save
        </button>
      </div>
    </>
  );
};

export default PatientInfo;
